<template>
	<n-modal v-model:show="show" :mask-closable="false" preset="card" class="w-[90vw]! max-w-140!" :closable="false">
		<n-spin :show="loadingValidation" content-class="p-3">
			<MfaForm
				ref="mfaFormRef"
				action="GENERIC_AUTH"
				size="small"
				:disabled="loadingValidation"
				@validate="handleSubmit"
				@error="handleError"
			>
				<template #header-extra>
					<JMButton circle text @click="show = false">
						<template #icon>
							<Icon name="carbon:close" :size="24" />
						</template>
					</JMButton>
				</template>
			</MfaForm>
		</n-spin>
	</n-modal>
</template>

<script setup lang="ts">
import type { MfaModel } from "./MfaForm.vue"
import type { I18nString } from "@/lang/config"
import type { APIError } from "@/types/common"
import { NModal, NSpin, useMessage } from "naive-ui"
import { ref, watch } from "vue"
import { useI18n } from "vue-i18n"
import Api from "@/api"
import Icon from "@/components/common/Icon.vue"
import JMButton from "@/components/common/JMButton.vue"
import { getApiErrorMessage } from "@/utils"
import MfaForm from "./MfaForm.vue"

const emit = defineEmits<{
	(e: "success", token: string): void
	(e: "error", error: Error): void
}>()

const show = defineModel<boolean | undefined>("show", { default: false })

const message = useMessage()
const { t } = useI18n()
const loadingValidation = ref<boolean>(false)
const mfaFormRef = ref<InstanceType<typeof MfaForm> | null>(null)

async function handleSubmit(otpModel: MfaModel) {
	if (loadingValidation.value) return

	loadingValidation.value = true

	try {
		const response = await Api.common.auth.validateOtp({
			otp: otpModel.otp || "",
			method: otpModel.otpMethod || "TOTP"
		})

		emit("success", response.data.temp_auth_token)
		show.value = false
	} catch (error) {
		message.error(getApiErrorMessage(error as APIError) || t<I18nString>(`common.misc.generic_error`))
	} finally {
		reset()
	}
}

function handleError(error: Error) {
	show.value = false
	emit("error", error)
}

function reset() {
	loadingValidation.value = false
	mfaFormRef.value?.resetOtpValue()
}

watch(
	show,
	val => {
		if (val) {
			reset()
		}
	},
	{ immediate: true }
)
</script>
